import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import Button from '../buttons/Button';

import styles from '../../../styles/partials/director.scss';
import image from '../../../img/director-photo.jpg';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Director = ({ className }) => {
    const [opened, setOpened] = useState(false);
    const onClickReadMore = useCallback(() => setOpened(!opened), [opened]);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.opened]: opened,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.content}>
                <div className={styles.inner}>
                    <h4 className={styles.title}>Director’s statement</h4>
                    <div className={styles.text}>
                        <p>
                            As a child, I grew up hearing elaborate stories about their childhoods
                            from my vibrant Ethiopian aunts – tales about their grandmother helping
                            the war effort against the Italians, meetings with fortune tellers,
                            hitchhiking in Europe, lavish cocktail parties, or sneaking out to go to
                            the beach. The stories were pleasurable and exciting, painting a vision
                            of a wonderful past. However, I could never decipher which stories were
                            true and which ones had been spiced up with their typical Ethiopian
                            romanticism.
                        </p>
                        <div className={styles.moreText}>
                            <p>
                                Lost in all their stories was Sally, a family member that no one
                                ever mentioned to me. It wasn’t until my early 30s that I had
                                stumbled upon a photo of Sally, but the family was hesitant to talk
                                about her. Little by little, I managed to convince my grandmother
                                and then my aunts to share Sally’s story.
                            </p>
                            <p>
                                Each of my aunts has her own version of events and point of view
                                regarding Sally. However, despite their differences in opinion, my
                                aunts all share a common sense of loss. The film poses the question
                                that arises when someone you love disappears without a trace: how do
                                you cope? It explores not only how my family has managed this loss,
                                but also how the entire country has managed the loss, pain, and
                                trauma of the Red Terror (a period of sustained state violence). My
                                family is just a small example of how many Ethiopians are still
                                dealing with those deaths, and how the fear of public mourning under
                                the military government forced so many people to suffer in silence. 
                            </p>
                            <p>
                                My aunt Sally and many of her peers lost their lives fighting for
                                what they believed could be a better Ethiopia. They envisioned a
                                united and democratic Ethiopia that would embrace everyone equally –
                                something I think is still possible despite the dangerous ethnic
                                divisions that plague Ethiopia today.
                            </p>
                            <p>
                                I hope that Finding Sally can be a plea for freedom of speech and
                                critical thinking, and also an indictment of silence in general in
                                Ethiopia. Even today, as young people frequently protest the
                                government, their elders are still hesitant to talk about their own
                                activism and past losses which closely mirror many aspects of the
                                present-day situation. I hope that this film can be a catalyst to
                                discussing the country’s past and engaging in critical discourse
                                about the road ahead.
                            </p>
                        </div>

                        <Button onClick={onClickReadMore} className={styles.readMore}>
                            {opened ? 'Close' : 'Read more'}
                        </Button>
                    </div>
                </div>
            </div>
            <div className={styles.image}>
                <img src={image} className={styles.photo} alt="Tamara" />
            </div>
        </div>
    );
};

Director.propTypes = propTypes;
Director.defaultProps = defaultProps;

export default Director;
